import { Button, Modal } from '@atom/mui';

import classes from './tasks.module.css';

type NoTaskGuardModalProps = {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onCreateWorkAnyway: () => void;
  onCreateTask: () => void;
};

const NoTaskGuardModal = (props: NoTaskGuardModalProps) => {
  const { open, loading, onCancel, onCreateWorkAnyway, onCreateTask } = props;

  const footer = (
    <div className={classes.guardFooter}>
      <Button onClick={onCancel} data-cy="createWorkModalGuardCancelButton">
        Cancel
      </Button>
      <div>
        <Button
          color="primary"
          onClick={onCreateWorkAnyway}
          disabled={loading}
          style={{ marginRight: '0.5rem' }}
          data-cy="createWorkModalGuardCreateAnywayButton"
        >
          Create Work Anyway
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onCreateTask}
          data-cy="createWorkModalGuardCreateTaskButton"
        >
          Create Task
        </Button>
      </div>
    </div>
  );

  return (
    <Modal
      title="Create Tasks Before Continuing?"
      open={open}
      footer={footer}
      loading={loading}
      data-cy="createWorkModalNoTaskGuard"
    >
      <div className={classes.guardContent}>
        Tasks help you organize and plan work more effectively. Do you want to
        create tasks before creating this work?
      </div>
    </Modal>
  );
};

export default NoTaskGuardModal;
